import Swal from "sweetalert2";
import i18n from "../i18n";
import { isFeatureEnabled } from "@/modules/shared/store/featureFlags";

const resolveTranslator = (t) => (typeof t === "function" ? t : i18n?.t?.bind(i18n));

// Switched from Tarh Portal (feature "upgrade_required_popup"). While it is off the popup
// is not shown anywhere; the access rules behind it still apply.
export const UPGRADE_REQUIRED_POPUP_FEATURE = "upgrade_required_popup";

export const showUpgradeRequiredPopup = ({ t, onUpgrade } = {}) => {
  if (!isFeatureEnabled(UPGRADE_REQUIRED_POPUP_FEATURE)) {
    return Promise.resolve({ isConfirmed: false, isDismissed: true });
  }

  return Swal.fire({
    title:
      resolveTranslator(t)?.("upgrade_required_title") || "Upgrade Required",
    html:
      resolveTranslator(t)?.("upgrade_required_message") ||
      "This feature is not included in your current plan.<br/>Please upgrade your subscription to access this feature.",
    icon: "warning",
    iconColor: "#c2410c",
    showCancelButton: true,
    confirmButtonText:
      resolveTranslator(t)?.("upgrade_required_confirm") || "Upgrade Now",
    cancelButtonText:
      resolveTranslator(t)?.("upgrade_required_cancel") || "Close",
    confirmButtonColor: "#1B8354",
  }).then((result) => {
    if (result.isConfirmed) {
      if (typeof onUpgrade === "function") {
        onUpgrade();
      } else {
        window.location.href = "/upgrade";
      }
    }
  });
};

export const showSubscribeFirstPopup = ({ t, onSubscribe } = {}) =>
  Swal.fire({
    title:
      resolveTranslator(t)?.("subscribe_first_title") ||
      "Subscription Required",
    html:
      resolveTranslator(t)?.("subscribe_first_message") ||
      "Please subscribe to a plan first to access Tarh services.",
    icon: "info",
    iconColor: "#1B8354",
    showCancelButton: true,
    confirmButtonText:
      resolveTranslator(t)?.("subscribe_first_confirm") || "View Plans",
    cancelButtonText:
      resolveTranslator(t)?.("upgrade_required_cancel") || "Close",
    confirmButtonColor: "#1B8354",
  }).then((result) => {
    if (result.isConfirmed) {
      if (typeof onSubscribe === "function") {
        onSubscribe();
      } else {
        window.location.href = "/subscribe";
      }
    }
  });

export const showSubscriptionExpiredPopup = ({ t, onRenew } = {}) =>
  Swal.fire({
    title:
      resolveTranslator(t)?.("subscription_expired_title") ||
      "Subscription Expired",
    html:
      resolveTranslator(t)?.("subscription_expired_message") ||
      "Your subscription has expired. Please renew your subscription to continue using the platform.",
    icon: "warning",
    iconColor: "#c2410c",
    showCancelButton: true,
    confirmButtonText:
      resolveTranslator(t)?.("subscription_expired_confirm") ||
      resolveTranslator(t)?.("renew_subscription") ||
      "Renew Subscription",
    cancelButtonText:
      resolveTranslator(t)?.("upgrade_required_cancel") || "Close",
    confirmButtonColor: "#1B8354",
  }).then((result) => {
    if (result.isConfirmed) {
      if (typeof onRenew === "function") {
        onRenew();
      } else {
        window.location.href = "/subscribe";
      }
    }
  });
